import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { cn } from '~/utils/common';

const TEST_PAGE_DATA = graphql(`
  query TestPageData {
    outcropList {
      results {
        id
        name
        thumbnail {
          id
          file {
            id
            name
          }
        }
        pictures {
          id
          file {
            id
            name
          }
        }
      }
    }
  }
`);

export default function TestPage() {
  return (
    <ApolloProviderV4>
      <TestPageInner />
    </ApolloProviderV4>
  );
}

function TestPageInner() {
  const { data, loading } = useQuery(TEST_PAGE_DATA);

  const outcrops = data?.outcropList?.results
    ?.map(oc => {
      const thumbnailName = oc.thumbnail?.file?.name?.replace('thumb-', '');
      const hasDuplicateThumbnail = thumbnailName
        ? oc.pictures.some(pic => pic.file.name === thumbnailName)
        : false;

      return {
        ...oc,
        hasDuplicateThumbnail,
      };
    })
    .sort(R.ascend(oc => oc.name));

  const duplicateCount =
    outcrops?.filter(oc => oc.hasDuplicateThumbnail).length ?? 0;

  if (loading) return <SpinnerPlaceholder />;

  return (
    <div className="container mx-auto max-w-7xl my-8">
      <p>
        <strong>{duplicateCount}</strong> of{' '}
        <strong>{outcrops?.length ?? 0}</strong> outcrops with the same picture
        uploaded to thumbnail and pictures.
      </p>

      <table className="table table-compact">
        <thead>
          <tr>
            <th>ID</th>
            <th>Outcrop</th>
            <th>Duplicated thumbnail name</th>
          </tr>
        </thead>
        <tbody>
          {outcrops?.map(oc => (
            <tr key={oc.id}>
              <td>{oc.id}</td>
              <td>{oc.name}</td>
              <td
                className={cn({ 'text-green-500': oc.hasDuplicateThumbnail })}
              >
                {oc.hasDuplicateThumbnail ? oc.thumbnail?.file.name : '--'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
